unit JobDetailForm;

interface

uses
  System.SysUtils,
  System.Classes,
  System.StrUtils,
  System.Math,
  System.Generics.Collections,
  JS,
  Web,
  WEBLib.Graphics,
  WEBLib.Controls,
  WEBLib.Forms,
  WEBLib.Dialogs,
  Data.DB,
  WEBLib.DB,
  Vcl.Controls,
  Vcl.StdCtrls,
  WEBLib.StdCtrls,
  WEBLib.DBCtrls,
  WEBLib.ExtCtrls,
  WEBLib.Lists,
  WEBLib.WebCtrls,
  WEBLib.Toast,
  WebForm.Core,
  JobDetailBaseForm;

type
  TJobDetail = class(TJobDetailBase)
    JobStats: THTMLSpan;
    JobInfo: THTMLDiv;
  private
    { Private declarations }
  protected
    procedure LoadStats(AData: JS.TJSObject); override;
  public
    { Public declarations }
  protected procedure LoadDFMValues; override; end;

var
  JobDetail: TJobDetail;

implementation

uses
  XData.Web.Client,
  MainForm,
  MainDataModule,
  SMX.Web.Utils,
  Auth.Service,
  SMX.Shared,
  JobErrorForm,
  SMX.Web.Service.Consts,
  SMX.Web.Jobs.Utils;

{$R *.dfm}

type
  TJobStatItem = record
    Caption: string;
    Value: string;
  end;

{ TJobDetail }

procedure TJobDetail.LoadStats(AData: JS.TJSObject);
var
  jItem: JS.TJSObject;
  aJS: JS.TJSArray;
  I, lCardCount, lCols: Integer;
  lCaption, lVal, lStatus, lJobType, lHtml, lNotes, lTitle, lSub: string;
  lDataset: TDataSet;
  lTimeTaken, lProgress: Double;
  lEl: TJSHTMLElement;
  lAll, lCards, lNotesList, lOrdered: TList<TJobStatItem>;
  lItem: TJobStatItem;
  lPreferred: TStringList;
  lUsed: TDictionary<string, Boolean>;
  lImported, lMerged, lInserted, lProgressDetail: string;
  lProcessedNum, lTotalHint: Integer;
  lActive: Boolean;

  procedure SetElText(const AId, AText: string);
  begin
    lEl := TJSHTMLElement(document.getElementById(AId));
    if Assigned(lEl) then
      lEl.textContent := AText;
  end;

  procedure AddPreferred(const ACaption: string);
  begin
    lPreferred.Add(ACaption);
  end;

  function IsNoteCaption(const ACaption, AValue: string): Boolean;
  begin
    Result := SameText(ACaption, 'Error') or SameText(ACaption, 'Warning') or
      SameText(ACaption, 'Submission') or SameText(ACaption, 'Qualifier') or
      SameText(ACaption, 'Import') or SameText(ACaption, 'Rollback Hook Error') or
      SameText(ACaption, 'Donation Total') or SameText(ACaption, 'Gift Aid Total') or
      SameText(ACaption, 'Merge Path') or SameText(ACaption, 'Inserted Records') or
      (Length(ACaption) > 40) or (Length(AValue) > 48);
  end;

  function IsErrorCaption(const ACaption: string): Boolean;
  begin
    Result := SameText(ACaption, 'Errors') or SameText(ACaption, 'Failed Donations') or
      SameText(ACaption, 'Error');
  end;

  function DisplayCaption(const ACaption: string): string;
  begin
    if SameText(ACaption, 'Imported') then
      Result := 'Processed'
    else if SameText(ACaption, 'Matched Donors') then
      Result := 'Matched donors'
    else if SameText(ACaption, 'Merged Records') then
      Result := 'Merged records'
    else if SameText(ACaption, 'Inserted Records') then
      Result := 'Inserted records'
    else if SameText(ACaption, 'New Donors') then
      Result := 'New donors'
    else if SameText(ACaption, 'Import Batch') then
      Result := 'Import batch'
    else if SameText(ACaption, 'Included Donations') then
      Result := 'Included'
    else if SameText(ACaption, 'Failed Donations') then
      Result := 'Failed'
    else if SameText(ACaption, 'Donations Amount') then
      Result := 'Amount'
    else if SameText(ACaption, 'Donations Gift Aid') then
      Result := 'Gift Aid'
    else if SameText(ACaption, 'Other Income GiftAid') then
      Result := 'Other income GA'
    else if SameText(ACaption, 'Aggregated Donations') or SameText(ACaption, 'Aggregated Donation') then
      Result := 'Aggregated'
    else if SameText(ACaption, 'Sales records marked') then
      Result := 'Marked paid'
    else
      Result := ACaption;
  end;

  function Cell(const ALabel, AValue: string; AErrorStat: Boolean): string;
  var
    lClass: string;
  begin
    lClass := 'job-detail-stat-value';
    if AErrorStat and ((AValue = '0') or (AValue = '')) then
      lClass := lClass + ' is-ok';
    if AValue = '' then
      Result := Format(
        '<div class="job-detail-stat"><div class="job-detail-stat-label">%s</div>' +
        '<div class="%s">—</div></div>', [ALabel, lClass])
    else
      Result := Format(
        '<div class="job-detail-stat"><div class="job-detail-stat-label">%s</div>' +
        '<div class="%s">%s</div></div>', [ALabel, lClass, AValue]);
  end;

  function FindValue(AList: TList<TJobStatItem>; const ACaption: string): string;
  var
    K: Integer;
  begin
    Result := '';
    for K := 0 to AList.Count - 1 do
      if SameText(AList[K].Caption, ACaption) then
        Exit(AList[K].Value);
  end;

begin
  JobStats.HTML.Clear;
  lAll := TList<TJobStatItem>.Create;
  lCards := TList<TJobStatItem>.Create;
  lNotesList := TList<TJobStatItem>.Create;
  lOrdered := TList<TJobStatItem>.Create;
  lUsed := TDictionary<string, Boolean>.Create;
  lPreferred := TStringList.Create;
  try
    lJobType := '';
    lStatus := '';
    lActive := False;
    lImported := '';
    lMerged := '';
    lInserted := '';
    lProgressDetail := '';
    lDataset := nil;
    if Assigned(DataSource) then
      lDataset := DataSource.Dataset;
    if Assigned(lDataset) and lDataset.Active and (not lDataset.IsEmpty) then
    begin
      try
        lJobType := lDataset.FieldByName('JobType').AsString;
        lStatus := lDataset.FieldByName('Status').AsString;
        lActive := JobStatusIsActive(lStatus);
      except
      end;
    end;

    if Assigned(AData) then
    begin
      aJS := JS.toArray(AData['value']);
      if aJS <> nil then
        for I := 0 to aJS.Length - 1 do
        begin
          jItem := JS.toObject(aJS[I]);
          lCaption := Trim(JS.toString(jItem['caption']));
          lVal := Trim(JS.toString(jItem['value']));
          if lCaption = '' then
            Continue;
          if SameText(lCaption, 'Progress Detail') then
          begin
            lProgressDetail := lVal;
            Continue;
          end;
          lItem.Caption := lCaption;
          lItem.Value := lVal;
          lAll.Add(lItem);
          if SameText(lCaption, 'Imported') then
            lImported := lVal
          else if SameText(lCaption, 'Merged Records') then
            lMerged := lVal
          else if SameText(lCaption, 'Inserted Records') then
            lInserted := lVal;
          if IsNoteCaption(lCaption, lVal) then
            lNotesList.Add(lItem)
          else
            lCards.Add(lItem);
        end;
    end;

    if ContainsText(lJobType, 'ImportMerge') then
    begin
      AddPreferred('Merged Records');
      AddPreferred('New Donors');
      AddPreferred('Matched Donors');
      AddPreferred('Import Batch');
    end
    else if ContainsText(lJobType, 'DonationImport') then
    begin
      AddPreferred('Imported');
      AddPreferred('Valid');
      AddPreferred('Errors');
      AddPreferred('Matched Donors');
    end
    else if ContainsText(lJobType, 'PrepareClaim') or ContainsText(lJobType, 'GiftAidClaim') or
      ContainsText(lJobType, 'MarkPaid') then
    begin
      AddPreferred('Included Donations');
      AddPreferred('Failed Donations');
      AddPreferred('Donations Amount');
      AddPreferred('Donations Gift Aid');
      AddPreferred('Aggregated Donations');
      AddPreferred('Aggregated Donation');
      AddPreferred('GASDS Amount');
      AddPreferred('GASDS Gift Aid');
      AddPreferred('GASDS Adjustment');
      AddPreferred('Other Income');
      AddPreferred('Other Income Gift Aid');
      AddPreferred('Other Income GiftAid');
      AddPreferred('Community Buildings Amount');
      AddPreferred('Community Buildings Gift Aid');
      AddPreferred('Adjustment');
      AddPreferred('Count');
      AddPreferred('Sales records marked');
    end;

    if lPreferred.Count > 0 then
    begin
      for I := 0 to lPreferred.Count - 1 do
      begin
        lVal := FindValue(lCards, lPreferred[I]);
        if lVal <> '' then
        begin
          lItem.Caption := lPreferred[I];
          lItem.Value := lVal;
          lOrdered.Add(lItem);
          lUsed.AddOrSetValue(UpperCase(lPreferred[I]), True);
        end;
      end;
      for I := 0 to lCards.Count - 1 do
        if not lUsed.ContainsKey(UpperCase(lCards[I].Caption)) then
          lOrdered.Add(lCards[I]);
      lCards.Clear;
      for I := 0 to lOrdered.Count - 1 do
        lCards.Add(lOrdered[I]);
    end;

    { Stopped jobs: keep only outcome/state stats (e.g. Outcome=Rolled back). }
    if JobStatusIsStopped(lStatus) then
    begin
      for I := lCards.Count - 1 downto 0 do
        if not JobStatIsOutcomeState(lCards[I].Caption) then
          lCards.Delete(I);
      for I := lNotesList.Count - 1 downto 0 do
        if not JobStatIsOutcomeState(lNotesList[I].Caption) then
          lNotesList.Delete(I);
      lImported := '';
      lMerged := '';
      lInserted := '';
      lProgressDetail := '';
    end;

    if JobStatusIsStopped(lStatus) then
    begin
      if (lCards.Count > 0) or (lNotesList.Count > 0) then
      begin
        lTitle := 'Outcome';
        lSub := '';
      end
      else
      begin
        lTitle := '';
        lSub := '';
      end;
    end
    else if ContainsText(lJobType, 'ImportMerge') then
    begin
      if lActive then
      begin
        lTitle := 'Merge results so far';
        lSub := 'Totals update as each merge stage completes.';
      end
      else
      begin
        lTitle := 'Merge results';
        lSub := '';
      end;
    end
    else if ContainsText(lJobType, 'DonationImport') then
    begin
      if lActive then
      begin
        lTitle := 'Import results so far';
        lSub := 'Live totals update as rows are processed.';
      end
      else
      begin
        lTitle := 'Import results';
        lSub := '';
      end;
    end
    else if ContainsText(lJobType, 'PrepareClaim') then
    begin
      lTitle := 'Prepare claim results';
      lSub := 'Donation and schedule totals from this prepare run.';
    end
    else if ContainsText(lJobType, 'GiftAidClaim') then
    begin
      lTitle := 'Claim results';
      lSub := 'Donation and schedule totals from this claim run.';
    end
    else if ContainsText(lJobType, 'MarkPaid') then
    begin
      lTitle := 'Mark paid results';
      lSub := '';
    end
    else if lActive then
    begin
      lTitle := 'Results so far';
      lSub := 'Totals update while the job is running.';
    end
    else
    begin
      lTitle := 'Job results';
      lSub := '';
    end;

    SetElText('JobResultsTitle', lTitle);
    SetElText('JobResultsSub', lSub);
    lEl := TJSHTMLElement(document.getElementById('JobResultsSub'));
    if Assigned(lEl) then
    begin
      if lSub = '' then
        lEl.style.setProperty('display', 'none')
      else
        lEl.style.setProperty('display', '');
    end;

    if lProgressDetail <> '' then
    begin
      SetElText('JobProgressDetail', lProgressDetail);
      SetElText('JobProgressRemaining', '');
    end
    else if lImported <> '' then
    begin
      lProcessedNum := StrToIntDef(StringReplace(lImported, ',', '', [rfReplaceAll]), 0);
      SetElText('JobProgressDetail', Format('%s rows processed', [lImported]));
      lProgress := 0;
      if Assigned(lDataset) and lDataset.Active and (not lDataset.FieldByName('Progress').IsNull) then
        lProgress := lDataset.FieldByName('Progress').AsFloat;
      if JobStatusIsStopped(lStatus) then
        SetElText('JobProgressRemaining', '')
      else if (lProgress > 0) and (lProgress < 100) and (lProcessedNum > 0) then
      begin
        lTotalHint := Trunc(lProcessedNum / (lProgress / 100.0));
        if lTotalHint > lProcessedNum then
          SetElText('JobProgressRemaining',
            Format('%s rows remaining (est.)', [FormatFloat('#,##0', lTotalHint - lProcessedNum)]))
        else
          SetElText('JobProgressRemaining', '');
      end
      else
        SetElText('JobProgressRemaining', '');
    end
    else if lMerged <> '' then
    begin
      if lInserted <> '' then
        SetElText('JobProgressDetail', Format('%s records merged, %s records inserted',
          [lMerged, lInserted]))
      else
        SetElText('JobProgressDetail', Format('%s records merged', [lMerged]));
      SetElText('JobProgressRemaining', '');
    end
    else if (lCards.Count > 0) and lActive then
    begin
      SetElText('JobProgressDetail', Format('%s: %s',
        [DisplayCaption(lCards[0].Caption), lCards[0].Value]));
      SetElText('JobProgressRemaining', '');
    end
    else
    begin
      SetElText('JobProgressDetail', '');
      SetElText('JobProgressRemaining', '');
    end;

    lHtml := '';
    if lCards.Count > 0 then
    begin
      lCardCount := lCards.Count;
      if lCardCount > 8 then
        lCardCount := 8;
      lCols := Min(4, lCardCount);
      if (lCardCount = 3) then
        lCols := 3;
      lHtml := Format('<div class="job-detail-stat-grid cols-%d">', [lCols]);
      for I := 0 to lCardCount - 1 do
        lHtml := lHtml + Cell(DisplayCaption(lCards[I].Caption), lCards[I].Value,
          IsErrorCaption(lCards[I].Caption));
      lHtml := lHtml + '</div>';
      for I := lCardCount to lCards.Count - 1 do
        lNotesList.Add(lCards[I]);
    end;

    lNotes := '';
    for I := 0 to lNotesList.Count - 1 do
      lNotes := lNotes + Format(
        '<div class="job-detail-stat-extra"><span class="text-secondary">%s:</span> %s</div>',
        [lNotesList[I].Caption, lNotesList[I].Value]);

    if Assigned(lDataset) and lDataset.Active and (not lDataset.IsEmpty) then
    begin
      try
        if (not JobStatusIsStopped(lStatus)) and
          ((lStatus = 'Complete') or (lStatus = 'Processed') or (lStatus = 'Preview') or
           (lStatus = 'NothingToDo')) then
        begin
          lTimeTaken := 0;
          if not lDataset.FieldByName('TimeTaken').IsNull then
            lTimeTaken := lDataset.FieldByName('TimeTaken').AsFloat;
          if lTimeTaken > 0 then
            lNotes := lNotes + Format(
              '<div class="job-detail-stat-extra">Time taken: <strong>%s</strong></div>',
              [TUtils.SecondsAsTime(Trunc(lTimeTaken))]);
        end;
      except
      end;
    end;

    JobStats.HTML.Text := lHtml + lNotes;
    JobInfo.Visible := (lHtml <> '') or (lNotes <> '');
  finally
    lPreferred.Free;
    lUsed.Free;
    lOrdered.Free;
    lNotesList.Free;
    lCards.Free;
    lAll.Free;
  end;
end;

procedure TJobDetail.LoadDFMValues;
begin
  inherited LoadDFMValues;

  JobInfo := THTMLDiv.Create('JobInfo');
  JobStats := THTMLSpan.Create('JobStats');

  DownloadFiles.BeforeLoadDFMValues;
  FileList.BeforeLoadDFMValues;
  JobInfo.BeforeLoadDFMValues;
  JobStats.BeforeLoadDFMValues;
  try
    ElementClassName := 'PopUpForm job-detail-popup';
    FileList.Items.Clear;
    with FileList.Items.Add do
    begin
      ItemClassName := 'list-group-item';
      LinkClassName := 'list-group-link';
      Text := 'Item 0';
    end;
    with FileList.Items.Add do
    begin
      ItemClassName := 'list-group-item';
      LinkClassName := 'list-group-link';
      Text := 'Item 1';
    end;
    with FileList.Items.Add do
    begin
      ItemClassName := 'list-group-item';
      LinkClassName := 'list-group-link';
      Text := 'Item 2';
    end;
    JobInfo.SetParentComponent(Self);
    JobInfo.Name := 'JobInfo';
    JobInfo.Left := 304;
    JobInfo.Top := 287;
    JobInfo.Width := 169;
    JobInfo.Height := 144;
    JobInfo.HeightStyle := ssAuto;
    JobInfo.WidthStyle := ssAuto;
    JobInfo.ChildOrder := 19;
    JobInfo.ElementPosition := epIgnore;
    JobInfo.ElementFont := efCSS;
    JobInfo.Role := '';
    JobStats.SetParentComponent(JobInfo);
    JobStats.Name := 'JobStats';
    JobStats.Left := 9;
    JobStats.Top := 44;
    JobStats.Width := 144;
    JobStats.Height := 60;
    JobStats.HeightStyle := ssAuto;
    JobStats.WidthStyle := ssAuto;
    JobStats.ChildOrder := 14;
    JobStats.ElementPosition := epIgnore;
    JobStats.ElementFont := efCSS;
    JobStats.Role := '';
  finally
    DownloadFiles.AfterLoadDFMValues;
    FileList.AfterLoadDFMValues;
    JobInfo.AfterLoadDFMValues;
    JobStats.AfterLoadDFMValues;
  end;
end;

end.
